import { Component, ViewChild } from "@angular/core";
import {
  Platform,
  IonicApp,
  Nav,
  Events,
  ToastController,
  App,
  MenuController,
} from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Keyboard } from "@ionic-native/keyboard";
import { Network } from "@ionic-native/network";
import { Badge } from "@ionic-native/badge";
import { BackgroundMode } from "@ionic-native/background-mode";
import { LocalNotifications } from "@ionic-native/local-notifications";
import {
  GlobalState,
  StorageService,
  DialogService,
  RouterService,
  Utils,
  EventService,
  LoadingService,
} from "../services/common";
import { FingerPrintHelper } from "../services/common/fingerprint-helper";
import { CacheDataService } from "../services/business/cache-data/cache-data.service";
import { LoginService } from "../services/business/login/login.service";
import { TranslateService } from "@ngx-translate/core";
import {
  APP_PLATFORM_THIRD,
  INVARIANT,
  AppConfiguration,
  THIRD_PAGE,
} from "../config";
import { Observable } from "rxjs";
declare var dd;

@Component({
  templateUrl: "app.html",
  providers: [LoginService],
})
export class MyApp {
  @ViewChild("myNav") nav: Nav;
  rootPage: any;
  rootParams: any;
  allLang: Array<string> = ["en", "zh"];
  Intl: any;
  devices: string;

  constructor(
    public platform: Platform,
    private network: Network,
    private badge: Badge,
    private localNotification: LocalNotifications,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private keyboard: Keyboard,
    private router: RouterService,
    public global: GlobalState,
    public storageSer: StorageService,
    public dialogSer: DialogService,
    private translateSer: TranslateService,
    private ionicApp: IonicApp,
    private event: Events,
    private toastCtrl: ToastController,
    private fingerSer: FingerPrintHelper,
    private cacheSer: CacheDataService,
    private loginSer: LoginService,
    private app: App,
    private appConfig: AppConfiguration,
    private backgroundMode: BackgroundMode,
    private utils: Utils,
    private eventSer: EventService,
    private loadSer: LoadingService,
    private menuCtrl: MenuController,
  ) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
      this.devices = this.appConfig.getPlatform();
      //禁用键盘联想拦
      !APP_PLATFORM_THIRD && this.keyboard.hideFormAccessoryBar(true);
      /** 初始化主题 */
      this.storageSer.getStore(INVARIANT._SYS_THEME).then((theme) => {
        theme === null && (theme = "theme-default");
        this.global.init({ theme: theme });
      });

      /** 初始化国际化 */
      this.initTranslate().then((res) => {
        /** 进入root页面之前 初始化所有的页面需要参数 初始化失败会在登录时重新初始化一遍 初始化失败 则登录也失败 */

        // 系统参数不再在启动时预拉，改由登录成功后 cacheSysDatas 触发，避免登录前请求系统数据接口
        const promiseArr = [
          this.storageSer.getStore(INVARIANT._SYS_SETUP_FLAG),
        ].map((pro) => {
          return pro.catch((err) => false);
        });
        Promise.all(promiseArr)
          .then(
            (initResult) => {
              const flag = initResult[0];
              !APP_PLATFORM_THIRD && this.initNativePermission(flag); //初始化app权限
              !APP_PLATFORM_THIRD && this.notificationListener(); //通知栏点击监听
              this.initRoot(flag); //初始化根页面
            },
            (err) => {
              console.error("system cache data err", err);
              this.global.set("initSystem", false);
            },
          )
          .catch((err) => {
            console.error("system cache data err", err);
            this.global.set("initSystem", false);
          });
      });

      this.eventSer.evExitLogin.subscribe((fun) => {
        this.loginSer.exitLogin().then(
          (res) => {
            if (typeof fun == "function") {
              fun();
            }
          },
          (err) => console.log(err),
        );
      });

      /** 浏览器返回键注册 */
      this.devices == "windows" && this.setupBackButtonBehavior();

      /** 物理返回键注册 */
      this.devices != "windows" && this.registerBackButtonAction();

      /** APP运行初始状态的时候监听网络 */
      !APP_PLATFORM_THIRD &&
        this.network.onDisconnect().subscribe(
          () => {
            //监听网络连接断开的时候给出提示
            this.toastCtrl
              .create({
                message: this.Intl.COMMON.ERROR.NETWORK_ERROR,
                duration: 3000,
                position: "top",
              })
              .present();
          },
          (err) => console.log(err),
        );

      /** 程序从后台运行进入前台 */
      !APP_PLATFORM_THIRD &&
        document.addEventListener(
          "resume",
          () => {
            this.lockLogin();
          },
          false,
        );

      /** 程序进入后台运行 */
      !APP_PLATFORM_THIRD &&
        document.addEventListener(
          "pause",
          () => {
            console.log("pause");
          },
          false,
        );
    });
  }

  setupBackButtonBehavior() {
    // Register browser back button action(s)
    window.onpopstate = (evt) => {
      this.dealBackBtn();
    };
    if (window.location.protocol !== "file:") {
      // Fake browser history on each view enter
      this.app.viewDidEnter.subscribe((app) => {
        history.pushState(null, document.title, location.href);
        //history.pushState (null, null, "");
      });
    }
    // Fake browser history on each view enter
    // this.app.viewDidEnter.subscribe((app) => {
    //   history.pushState(null, document.title, location.href);
    // });
  }

  /**
   * 初始化系统需要缓存的参数
   */
  initSystemDatas(): Promise<any> {
    this.loadSer.showLoading(this.Intl.LOADING.LOADING_TEXT);
    return new Promise((resolve) => {
      this.cacheSer.cacheSysDatas().then(
        (sysDatasArr) => {
          resolve(sysDatasArr);
          this.loadSer.hideLoading();
        },
        (err) => {
          resolve(false);
          this.loadSer.hideLoading();
        },
      );
    });
  }

  /**
   * 初始化跟页面
   */
  initRoot(flag) {
    const url = this.utils.getUrlParams();
    console.log("url", url);
    if (url) {
      //第三方接入
      const {
        appUrl,
        pageName,
        code = "",
        ticket,
        pcUrl,
        state,
        userAccount,
        corpId,
      } = url.params;
      console.log("pagename", pageName);
      let redirectUrl = decodeURIComponent(appUrl);
      let dd_corpId = corpId;
      if (corpId) {
        const cutIndex = corpId.indexOf("#/tabs/");
        if (cutIndex != -1) {
          dd_corpId = corpId.substr(0, cutIndex);
        }
        console.log(corpId + "=============" + dd_corpId);
      }
      switch (pageName) {
        case "WeChat":
          //盛丰 微信企业号集成
          console.log("wechat");
          const weChatParams = {
            isPointLogin: "1",
            deviceAppUUID: "0",
            code: code,
            pageName: pageName,
            username: "",
            password: "",
            ticket: "",
          };
          return this.loginSer.thirdPltLogin(weChatParams).subscribe(
            (res) => {
              this.rootPage = url.page;
              this.rootParams = { fromPage: url.params };
            },
            (err) => {
              if (err.code === false) return;
              this.dialogSer.alert(err.returnMessage);
              this.rootPage = "ErrorPage";
            },
          );
        case "DingDing":
          console.log("DingDing");
          const that = this;
          return dd.runtime.permission.requestAuthCode({
            corpId: dd_corpId,
            onSuccess: function (result) {
              console.log("code", result);
              const prmam = {
                deviceAppUUID: "0",
                isPointLogin: "1",
                pageName: "DingDing",
                result: result.code,
                username: "",
                password: "",
              };
              return that.loginSer.thirdPltLogin(prmam).subscribe(
                (res) => {
                  console.log("跳转首页");
                  that.rootPage = "tabs";
                  // that.router.forward("TabsPage");
                  // that.cacheSer.initHomeTem(res.id)
                  // that.router.forward('TabsPage');
                },
                (err) => {
                  that.rootPage = "login";
                },
              );
            },
            onFail: function (err) {},
          });
        case "WeaverPage":
          //国信 爱信集成
          console.log("为啥WeaverPage");
          const weaveParams = {
            isPointLogin: "1",
            deviceAppUUID: "0",
            username: "",
            password: userAccount,
            ticket: ticket,
            pageName: pageName,
            code: code,
            state: state,
            userAccount: userAccount,
          };
          return this.loginSer.thirdPltLogin(weaveParams).subscribe(
            (res) => {
              this.rootPage = url.page;
              this.rootParams = { fromPage: url.params };
            },
            (err) => {
              if (err.code === false) return;
              this.dialogSer.alert(err.returnMessage);
              this.rootPage = "ErrorPage";
            },
          );
        case "IAMPage":
          if (code == "") {
            return this.loginSer
              .findAdSysParamsByCode("IAM_APP_OAUTH_URL")
              .subscribe(
                (res) => {
                  // if(res.datas.paramValues) {
                  //   window.location.href = res.datas.paramValues;
                  // }
                },
                (err) => {
                  if (err.code === false) return;
                  this.dialogSer.alert(err.returnMessage);
                  this.rootPage = "ErrorPage";
                },
              );
          } else {
            const userParam = {
              code: code,
              state: state,
            };
            return this.loginSer.getUserAccount(userParam).subscribe(
              (res) => {
                if (res.datas) {
                  const appParam = {
                    isPointLogin: "1",
                    deviceAppUUID: "0",
                    username: "",
                    password: res.datas,
                    pageName: pageName,
                    code: code,
                    state: state,
                    userAccount: res.datas,
                  };
                  return this.loginSer.IAMLogin(appParam).subscribe(
                    (res) => {
                      this.router.setRoot("tabs");
                    },
                    (err) => {
                      if (err.code === false) return;
                      this.dialogSer.alert(err.returnMessage);
                      this.rootPage = "ErrorPage";
                    },
                  );
                }
              },
              (err) => {
                if (err.code === false) return;
                this.dialogSer.alert(err.returnMessage);
                this.rootPage = "ErrorPage";
              },
            );
          }
        case "userAgentCheck":
          if (code !== "" && code !== null && code !== undefined) {
            redirectUrl = redirectUrl + "&code=" + code;
          }
          if (state !== "" && state !== null && state !== undefined) {
            redirectUrl = redirectUrl + "&state=" + state;
          }
          return (window.location.href =
            /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
              ? redirectUrl
              : decodeURIComponent(pcUrl));
        default:
          this.rootPage = "ErrorPage";
          return;
      }
    } else if (APP_PLATFORM_THIRD) {
      //第三方接入之后用户手动点了刷新按钮
      //如果集成在第三方平台直接走配置页面或者错误页面
      return (this.rootPage = THIRD_PAGE ? THIRD_PAGE : "ErrorPage");
    }
    if (!flag) return (this.rootPage = "WelcomePage");
    this.storageSer.getStore(INVARIANT._USER_USERINFO).then((userInfo) => {
      if (userInfo == null) return (this.rootPage = "login");
      this.global.set("userInfo", userInfo);
      Observable.forkJoin([
        this.fingerSer.getUseTouchid(),
        this.fingerSer.getLocalGesture(true),
      ]).subscribe(
        (resArr) => {
          console.log(resArr);
          const auth = resArr.some((i) => i);
          if (auth) return (this.rootPage = "AuthLoginPage");
          /** 初始化用户相关参数 */
          this.loginSer.initUserAbout(userInfo, false).then(
            (res) => {
              this.rootPage = "tabs";
            },
            (err) => {
              this.toastCtrl
                .create({
                  message:
                    this.Intl.COMMON &&
                    this.Intl.COMMON.TOAST.INIT_USERINFO_FAIL,
                  duration: 3000,
                  position: "middle",
                })
                .present();
              this.rootPage = "login";
              console.error(`用户信息初始化失败 重新登录! --${err}`);
            },
          );
        },
        (err) => {
          console.log(err);
        },
      );
    });
  }

  /** app从后台进入前台时页面走向 */
  lockLogin() {
    if (!this.global.state.userInfo) return; //没有初始化全局用户信息说明未登录 不做处理
    const activeVC = this.app.getActiveNav();
    const activeVCname = activeVC.getActive().name;
    console.log(activeVCname);
    if (activeVCname == "AuthLoginPage") return; //如果当前页面已经是安全验证页面 不做处理
    Observable.forkJoin([
      this.fingerSer.getUseTouchid(),
      this.fingerSer.getLocalGesture(true),
    ]).subscribe((resArr) => {
      console.log(resArr);
      const auth = resArr.some((i) => i);
      if (auth) {
        this.router.forward("AuthLoginPage", { isPause: true });
      }
    });
  }

  /**
   * 初始化语言
   */
  initTranslate(): Promise<any> {
    return new Promise((resolve) => {
      this.translateSer.addLangs(this.allLang);
      this.allLang.forEach((lang) => this.translateSer.setDefaultLang(lang)); //设置的语言都要set一遍 不然切换的时候不更新
      this.storageSer.getStore(INVARIANT._SYS_LOCAL_LANGUAGE).then(
        (localLanguage) => {
          console.log(localLanguage);
          let localLang = "zh";
          if (localLanguage !== null) {
            localLang = localLanguage;
          } else if (this.translateSer.getBrowserLang() !== undefined) {
            localLang = this.translateSer.getBrowserLang();
          }
          this.translateSer.use(localLang).subscribe((_) => {
            this.storageSer.setStore(INVARIANT._SYS_LOCAL_LANGUAGE, localLang);
            this.translateSer.get("COMMON").subscribe((v) => (this.Intl = v));
            resolve(true);
          });
        },
        (err) => resolve(false),
      );
    });
  }

  /**
   * 初始化权限 只在欢迎页询问一次 后续可追加每次询问和不再询问
   */
  async initNativePermission(flag) {
    if (flag || this.devices == "windows") return; //已经浏览器中或者初始化直接return
    //初始化本地推送
    const lnPermission = await this.localNotification.hasPermission();
    if (lnPermission) {
      this.storageSer.setStore(
        INVARIANT._SYS_LOCAL_NOTIFICATION_SUPPORT_PERMISSION,
        true,
      );
    } else {
      const req = await this.localNotification.requestPermission();
      this.storageSer.setStore(
        INVARIANT._SYS_LOCAL_NOTIFICATION_SUPPORT_PERMISSION,
        req,
      );
    }
    //初始化角标权限
    // const support = await this.badge.isSupported();
    // if (!support) return this.storageSer.setStore(INVARIANT._SYS_BADGE_SUPPORT_PERMISSION, false);
    const bgPermission = await this.badge.hasPermission();
    if (bgPermission) {
      this.storageSer.setStore(INVARIANT._SYS_BADGE_SUPPORT_PERMISSION, true);
    } else {
      const req = await this.badge.requestPermission();
      this.storageSer.setStore(INVARIANT._SYS_BADGE_SUPPORT_PERMISSION, req);
    }
  }

  /**
   * 点击通知栏事件
   */
  notificationListener() {
    return;
    // 由于打包监听报错,暂且注释
    // if (this.devices == 'windows') return;//已经浏览器中或者初始化直接return
    // this.backgroundMode.enable();//启用后台运行
    // this.localNotification.on("click").subscribe(noti => {
    //   const { data = {} } = noti;
    //   const { url, params } = data;
    //   console.log('local_notification-params: ', JSON.stringify(noti), '79999999');
    //   const activeVC = this.app.getRootNavs();
    //   console.log(activeVC, 'you get me now');
    //   const activeVCname = activeVC[0].getActive().name;
    //   console.log("activeVCname---", activeVCname);
    //   if (activeVCname == "AuthLoginPage") {
    //     this.event.publish("test_localNotification", { url: url, params: params });
    //   } else {
    //     this.router.forward(url, params);
    //   };
    // })
  }

  //安卓物理返回键的监听
  registerBackButtonAction() {
    this.platform.registerBackButtonAction(() => {
      this.dealBackBtn();
    }, 1);
  }

  dealBackBtn() {
    console.log("back is clicked");
    //如果有浮动层，则通过返回键关闭浮动层
    let activePortal =
      this.ionicApp._toastPortal.getActive() ||
      this.ionicApp._loadingPortal.getActive() ||
      this.ionicApp._overlayPortal.getActive() ||
      this.ionicApp._modalPortal.getActive();
    if (activePortal) {
      activePortal.dismiss().catch(() => {});
      return;
    }
    /**
     * 页面按照堆栈的形式进行跳转返回，对特殊页面返回需要对当前活动页面进行检测，然后特殊处理
     */
    // const activeVC = this.nav.getActive();
    // const activeVCname = activeVC.name;
    const activeVC = this.app.getActiveNav();
    const activeVCname = activeVC.getActive().name;
    if (
      activeVCname == "WelcomePage" ||
      activeVCname == "LoginPage" ||
      activeVCname == "AuthLoginPage"
    ) {
      this.platform.exitApp();
    } else if (this.nav.canGoBack()) {
      // 不做处理 按手机端的返回
      this.nav.pop();
      return;
    } else {
      try {
        const tabs = this.nav.getActiveChildNav();
        const tab = tabs.getSelected();
        const activeVC = tab.getActive();
        const activeNav = activeVC.getNav();
        if (activeNav.canGoBack()) {
          this.event.publish("android: back");
        } else {
          //弹出确认窗口确认是否退出
          this.showExit();
        }
      } catch (error) {
        console.log(error);
        this.showExit();
      }
    }
  }

  showExit() {
    if (this.devices == "windows") return;
    this.translateSer.get("COMMON").subscribe((v) => {
      console.log(v);
      this.dialogSer
        .create({
          title: v.EXIT_TITLE,
          message: v.EXIT_REMIND,
          buttons: [
            {
              text: v.BUTTON.CANCEL,
              role: "cancel",
            },
            {
              text: v.BUTTON.OK,
              handler: () => this.platform.exitApp(),
            },
          ],
        })
        .present();
    });
  }

  handleChangeRole() {
    this.menuCtrl.close();
    const role = {
      unitName: this.global.state.userInfo.unitName,
      entityName: this.global.state.userInfo.entityName,
    };
    this.router.forward("SelfInfoEditPage", {
      fromPage: { pageName: "SelfInfoPage", datas: { type: 0, role } },
    });
  }

  /**
   * 退出登录
   */
  exitLogin() {
    // const alert = this.dialogSer.alert(this.Intl.COMMON.ALERT.LOGINOUT, this.Intl.COMMON.ALERT.LOGINOUT_ENSURE, [{ text: this.Intl.COMMON.BUTTON.CANCEL, role: 'cancel' }, { text: this.Intl.COMMON.BUTTON.OK, role: 'ensure' }]);
    // alert.present();
    // alert.onDidDismiss((data, role) => {
    //   if (role == 'cancel') return;
    //   this.menuCtrl.close();
    //   this.loginSer.exitLogin().then(res => {
    //     this.router.setRoot('login');
    //     // this.appCtrl.getRootNav().setRoot('login');
    //   })
    // })
    this.menuCtrl.close();
    this.loginSer.exitLogin().then((res) => {
      this.router.setRoot("login");
      // this.appCtrl.getRootNav().setRoot('login');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts